import { render, staticRenderFns } from "./VendorData.vue?vue&type=template&id=653d1637"
import script from "./VendorData.vue?vue&type=script&lang=js"
export * from "./VendorData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports